import Config, { ENV } from "constants/Config";
import _ from "lodash";
import Axios from "axios";
import QS from "qs";

const BASE_URL = "https://studio.memopresso.com/api";

Axios.defaults.withCredentials = false;

const MemoAPI = {
	/**
	 * 讀取創作者資料
	 * @param {object} cursor { imp, id }
	 * @return {object} result
	 */
	GetCreators: async (cursor = {}) => {
		try {
			const { data } = await Axios.post(
				`https://data.memopresso.com/api/illustrator/list`,
				QS.stringify(cursor)
			);
			let { data: results = [] } = data;
			const list = _.map(results, (el) => {
				const { illustrator_id, imp, link_name, logo, name } = el;
				return {
					id: illustrator_id,
					imp: parseInt(imp),
					link_name,
					logo,
					name,
				};
			});
			return list;
		} catch (e) {
			throw new Error(`Error: Fail to load more creators : ${e}`);
		}
	},

	GetMpUserId: async (userId = "") => {
		try {
			const { data = {} } = await Axios.post(
				`https://data.memopresso.com/api/member/line`,
				JSON.stringify({
					user_id: userId,
				})
			);
			const { member = "" } = data;
			return member;
		} catch (error) {
			throw new Error(`Error: Fail to get member id : ${error}`);
		}
	},

	SendMail: async (message = {}) => {
		try {
			const { data } = await Axios.post(
				`${BASE_URL}/mp/sendServiceMail`,
				message
			);
			console.log(data);
			return;
		} catch (e) {
			throw new Error(`Error: Fail to send mail : ${e}`);
		}
	},

	GenBestNineStory: async (dataSet = {}) => {
		try {
			const { data } = await Axios.post(
				`${BASE_URL}/mp/genBestnineStory`,
				{
					dataSet,
				}
			);
			const { url } = data;
			return url;
		} catch (e) {
			throw new Error(`Error: Fail to gen bestnine story : ${e}`);
		}
	},

	GenBestNine: async (dataSet = {}) => {
		try {
			const { data } = await Axios.post(`${BASE_URL}/mp/genBestnine`, {
				dataSet,
			});
			const { url } = data;
			return url;
		} catch (e) {
			throw new Error(`Error: Fail to gen bestnine : ${e}`);
		}
	},

	UploadMedia: async (memberId = "", photo = []) => {
		try {
			if (!memberId || !photo.length) {
				return;
			}

			const { data } = await Axios.post(
				`https://data.memopresso.com/api/user/mediaupload`,
				JSON.stringify({
					member_id: memberId,
					photo,
				})
			);
		} catch (error) {
			console.log(error);
			throw new Error("Update Media : ", error);
		}
	},
};

export default MemoAPI;
